import classNames from 'classnames';
import React from 'react';
import { useI18n } from '@udemy/i18n';
import { Icon } from '@udemy/icons';
import { Modal } from '@udemy/react-dialog-components';
import { useSiteStats } from '@udemy/ud-data';
import { UnlockButton } from '../unlock-button/unlock-button.react-component';
import styles from "./locked-lecture-modal.module.css";
export const LockedLectureModal = ({
  isOpen,
  onClose
}) => {
  const {
    gettext,
    interpolate
  } = useI18n();
  const {
    getOrgNumericSiteStat
  } = useSiteStats();
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpen,
    onClose: onClose,
    renderTitle: () => ['locked-lecture-modal-title', null],
    title: "",
    className: "udlite-in-udheavy"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['content']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['icon-container']
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "play",
    label: false,
    color: "neutral",
    className: styles['play-icon']
  }), /*#__PURE__*/React.createElement("div", {
    className: styles['number-badge']
  }, 0)), /*#__PURE__*/React.createElement("h2", {
    id: "locked-lecture-modal-title",
    className: classNames('ud-heading-xxl', styles['title'])
  }, gettext("You've watched all your free videos")), /*#__PURE__*/React.createElement("div", {
    className: styles['subtitle']
  }, interpolate(gettext('Browse and explore over %(count)s top rated courses curated from Udemy.com'), {
    count: getOrgNumericSiteStat('num_courses').toLocaleString()
  }, true)), /*#__PURE__*/React.createElement(UnlockButton, {
    size: "large",
    onClick: onClose
  })));
};
//# sourceMappingURL=locked-lecture-modal.react-component.js.map